exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_oM0Tsh30yzWrDoI5Xlpe7 {\n\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.IA_DividerHR_2oxI9Libgf_r1cDz0XNnJo {\n  height: 0;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_oM0Tsh30yzWrDoI5Xlpe7",
	"IA_DividerHR": "IA_DividerHR_2oxI9Libgf_r1cDz0XNnJo"
};